import React from 'react'

export default function PlusCircleIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" fill="white"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#ECEBF7"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V16.5C12.75 16.9142 12.4142 17.25 12 17.25C11.5858 17.25 11.25 16.9142 11.25 16.5V7.5C11.25 7.08579 11.5858 6.75 12 6.75Z" fill="#B1AEC7"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M6.75 12C6.75 11.5858 7.08579 11.25 7.5 11.25L16.5 11.25C16.9142 11.25 17.25 11.5858 17.25 12C17.25 12.4142 16.9142 12.75 16.5 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12Z" fill="#B1AEC7"/>
        </svg>
    )
}
